import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* ANIMATED 404 */}
        <div className="relative mb-8">
          <h1 className="text-[200px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600 animate-pulse">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-64 h-64 bg-blue-500/20 rounded-full blur-3xl animate-ping"></div>
          </div>
        </div>

        {/* DRONE LOST ANIMATION */}
        <div className="mb-8 relative h-32">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 animate-bounce">
            <svg className="w-20 h-20 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.5 3c-.8 0-1.5.7-1.5 1.5v.7L17.5 7c-1-.5-2.2-.5-3.2 0L12 5.2V4.5c0-.8-.7-1.5-1.5-1.5S9 3.7 9 4.5v.7L7.5 7c-1-.5-2.2-.5-3.2 0L2.8 5.2V4.5C2.8 3.7 2.1 3 1.3 3S0 3.7 0 4.5v15c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-.7L4.5 17c1 .5 2.2.5 3.2 0L9 18.8v.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-.7l1.5-1.8c1 .5 2.2.5 3.2 0l1.5 1.8v.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-15c0-.8-.7-1.5-1.5-1.5z"/>
            </svg>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-6xl animate-spin-slow">🔍</div>
          </div>
        </div>

        {/* ERROR MESSAGE */}
        <h2 className="text-4xl font-bold text-white mb-4">
          Oops! Drone Lost Signal
        </h2>
        <p className="text-xl text-gray-300 mb-8">
          The page you're looking for has flown out of our geofence zone.
        </p>

        {/* STATS */}
        <div className="grid grid-cols-3 gap-4 mb-8 max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-blue-400">0</div>
            <div className="text-sm text-gray-400">Pages Found</div>
          </div>
          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-purple-400">404</div>
            <div className="text-sm text-gray-400">Error Code</div>
          </div>
          <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4 border border-white/20">
            <div className="text-2xl font-bold text-pink-400">∞</div>
            <div className="text-sm text-gray-400">Ways Home</div>
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => navigate('/')} 
            size="lg"
            variant="primary"
          >
            🏠 Return to Base
          </Button>
          <Button 
            onClick={() => navigate(-1)} 
            size="lg"
            variant="outline"
            className="text-white border-white hover:bg-white/10"
          >
            ← Go Back
          </Button>
        </div>

        {/* FUN QUOTE */}
        <p className="mt-12 text-gray-500 italic">
          "Not all who wander are lost... but this page definitely is." - Probably a drone
        </p>
      </div>
    </div>
  );
};